<template lang="html">
    <Card :bordered="false" shadow class="breadcrumb-bar">
        <!-- <span v-if="!isFullscreen&&!isMobile()" class="breadcrumb-bar-trigger" @click="handleTriggerTapped">
            <Icon v-if="triggerFlag" class="c-icon" custom="c-icon-11"></Icon>
            <Icon v-if="!triggerFlag" class="c-icon" custom="c-icon-12"></Icon>
        </span> -->
        <Breadcrumb v-if="name" separator="/" style="margin-left:0.2rem;">
            <BreadcrumbItem v-if="name">{{name}}</BreadcrumbItem>
            <BreadcrumbItem v-if="subName">{{subName}}</BreadcrumbItem>
        </Breadcrumb>
    </Card>
</template>

<script>
// import constants from "../utils/constants";
// import request from "../utils/request";
import util from "../utils/util";

export default {
    data() {
        return {
            triggerFlag: false,
            isFullscreen: false
        };
    },
    props: {
        name: {
            type: String,
            default: ''
        },
        subName: {
            type: String,
            default: ''
        }
    },
    mounted() {
        let self = this;
        ['fullscreenchange','webkitfullscreenchange','mozfullscreenchange'].forEach((item) => {
            document.addEventListener(item, () => {
                let isFullScreen = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen || document.fullscreenElement;
                self.isFullscreen = isFullScreen;
            });
        })
    },
    methods: {
        isMobile() {
            return util.isMobile();
        },
        handleTriggerTapped() {
            this.triggerFlag = !this.triggerFlag;
            this.$root.$emit("Sidebar_Collapsed", this.triggerFlag);
        }
    },
};
</script>

<style lang="less">
.breadcrumb-bar {
    .breadcrumb-bar-trigger {
        padding: 0px 12px;
        display: flex;
        align-items: center;
        cursor: pointer;
        transition: all .2s ease-in-out;
        &:hover {
            background-color: #F8F8F8;
        }
    }
    .ivu-breadcrumb {
        margin-left: 0.1rem;
        display: inline-block;
    }
    .ivu-card-body {
        display: flex !important;
        padding: 0;
        height: 64px;
        line-height: 64px;
    }
}
</style>
